import CategoryManagerState from "@/modules/category-manager";
import { ConversationBuilderState } from "@/modules/conversation-builder";
import TitleListState from "@/modules/title-list";
import { Paths } from "@/util/paths";
import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";

export const ComponentConversationResolver = async function (to: Route, form: Route, next: Function) {
	const titleListModule = getModule(TitleListState);
	const categoryModule = getModule(CategoryManagerState);
	const conversationStore = getModule(ConversationBuilderState);

	conversationStore.resetState();

	const actions: Promise<void>[] = [];
	if (!titleListModule.languageSkills.length) {
		actions.push(titleListModule.fetchLanguageSkills());
	}
	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}
	if (!titleListModule.tags.length) {
		actions.push(titleListModule.fetchVcsTags());
	}
	if (!categoryModule.categories.length) {
		actions.push(categoryModule.fetchCategories());
	}

	if (to.params.id) {
		actions.push(titleListModule.fetchContentDetails(to.params.id));
	} else {
		next(Paths.NotFound);
		return;
	}
	await Promise.all(actions);

	const { editeContentSelectedChapterId } = titleListModule;
	const contentId =
		editeContentSelectedChapterId !== "none" && editeContentSelectedChapterId !== "all"
			? editeContentSelectedChapterId
			: to.params.id;
	await conversationStore.fetchContentConversation(contentId);

	next();
};
